module.exports = __webpack_public_path__ + "img/yamaha.5f944238.png";